import React from 'react';
const IconMiscCreditCard = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2 4V16H4V11H20V18H2V20H22V4H2ZM20 8H4V6H20V8Z" fill="#2D2E2E"/>
<path d="M11 14H6V16H11V14Z" fill="#2D2E2E"/>
<path d="M15 14H13V16H15V14Z" fill="#2D2E2E"/>
</svg>
);
};
export default IconMiscCreditCard;